// Wizard question definitions (German). Modular for future additions.
export const QUESTIONS = [
  {
    key: "cameras",
    label: "Wie viele Kameras sollen eingebunden werden?",
    hint: "Grober Bereich oder unten die exakte Anzahl eintragen.",
    type: "single",
    exactField: "camerasExact",
    icon: "Video",
    options: [
      { value: "lt_25", label: "Bis 25" },
      { value: "26_50", label: "26 – 50" },
      { value: "51_100", label: "51 – 100" },
      { value: "101_500", label: "101 – 500" },
      { value: "gt_500", label: "Mehr als 500" },
    ],
  },
  {
    key: "sites",
    label: "Wie viele Standorte werden abgedeckt?",
    hint: "Einer, mehrere oder international verteilt.",
    type: "single",
    icon: "MapPin",
    options: [
      { value: "single", label: "Ein Standort" },
      { value: "multiple", label: "Mehrere Standorte" },
      { value: "international", label: "International verteilt" },
    ],
  },
  {
    key: "recordingServers",
    label: "Wie viele Recording Server sind geplant?",
    hint: "Ein einzelner, mehrere im selben System oder verteilt.",
    type: "single",
    icon: "Server",
    options: [
      { value: "single", label: "Ein Recording Server" },
      { value: "multiple", label: "Mehrere Recording Server" },
      { value: "distributed", label: "Verteilte Recording Server (Multi-Site)" },
    ],
  },
  {
    key: "failover",
    label: "Wird Failover / Redundanz benötigt?",
    hint: "Hot- oder Cold-Failover für Recording Server.",
    type: "boolean",
    icon: "ShieldCheck",
  },
  {
    key: "smartWall",
    label: "Wird XProtect Smart Wall benötigt?",
    hint: "Videowall / gemeinsame Operator-Ansicht.",
    type: "boolean",
    icon: "Monitor",
  },
  {
    key: "smartMap",
    label: "Benötigen Sie Smart Map?",
    hint: "Kartenbasierte Situationsvisualisierung.",
    type: "boolean",
    icon: "Map",
  },
  {
    key: "federatedArchitecture",
    label: "Sollen mehrere Systeme zentral verwaltet werden (Federation)?",
    hint: "Milestone Federated Architecture.",
    type: "boolean",
    icon: "Network",
  },
  {
    key: "evidenceLock",
    label: "Müssen Beweise revisionssicher geschützt werden (Evidence Lock)?",
    hint: "Unveränderbarkeit für Gerichtsverwertbarkeit.",
    type: "boolean",
    icon: "Lock",
  },
  {
    key: "secureEvidenceHandling",
    label: "Müssen Videos sicher an Behörden weitergegeben werden?",
    hint: "Secure Evidence Handling.",
    type: "boolean",
    icon: "Briefcase",
  },
  {
    key: "incidentManager",
    label: "Soll der XProtect Incident Manager genutzt werden?",
    hint: "Strukturiertes Logging & Dokumentation von Vorfällen.",
    type: "boolean",
    icon: "AlertTriangle",
  },
  {
    key: "dashboard",
    label: "Werden Operator-Dashboards benötigt?",
    hint: "Anpassbare Live-Übersichten für den Leitstand.",
    type: "boolean",
    icon: "LayoutDashboard",
  },
  {
    key: "deviceManagement",
    label: "Sollen Firmware-Updates zentral (Bulk) durchgeführt werden?",
    hint: "Bulk-Firmware, Device Password Management.",
    type: "boolean",
    icon: "Cpu",
  },
  {
    key: "cyberSecurity",
    label: "Welche Cyber-Security-Funktionen werden benötigt?",
    hint: "Mehrfachauswahl möglich.",
    type: "multi",
    icon: "ShieldAlert",
    subOptions: [
      { value: "oidcSSO", label: "OIDC / SSO (externer Identity Provider)" },
      { value: "twoFactor", label: "Zwei-Faktor-Authentifizierung" },
      { value: "digitalSignatures", label: "Digitale Signaturen" },
      { value: "encryption", label: "Verschlüsselung der Media-Datenbank" },
    ],
  },
  {
    key: "scalability",
    label: "Wie stark soll das System wachsen?",
    hint: "Zukunftsperspektive über 3–5 Jahre.",
    type: "single",
    icon: "TrendingUp",
    options: [
      { value: "none", label: "Keine Erweiterung geplant" },
      { value: "moderate", label: "Moderate Erweiterung" },
      { value: "strong", label: "Starkes Wachstum" },
    ],
  },
  {
    key: "criticality",
    label: "Wie wichtig ist die Videoanlage?",
    hint: "Kritikalität für den Betrieb.",
    type: "single",
    icon: "AlertOctagon",
    options: [
      { value: "standard", label: "Standard" },
      { value: "important", label: "Wichtig" },
      { value: "business_critical", label: "Unternehmenskritisch" },
      { value: "kritis", label: "KRITIS (Kritische Infrastruktur)" },
    ],
  },
];

export const DEFAULT_ANSWERS = () => ({
  cameras: null,
  camerasExact: "",
  sites: null,
  recordingServers: null,
  failover: false,
  smartWall: false,
  smartMap: false,
  federatedArchitecture: false,
  evidenceLock: false,
  secureEvidenceHandling: false,
  incidentManager: false,
  dashboard: false,
  deviceManagement: false,
  cyberSecurity: {},
  scalability: null,
  criticality: null,
});
